export default "__VITE_ASSET__CYNOsruh__"